import style from "@/styles/pages/ConfirmApplication/ConfirmApplication.module.css";
import { RootState } from "@/store/dtm";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useEffect } from "react";
import { setApplicationEndpointReached } from "@/slices/applicationSlice";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useNavigate } from "react-router-dom";
import { setClickInsightEvents } from "@/lib/util";

export default function ConfirmBridgeLoan() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );
  const referralProducts = useSelector((state: RootState) => state.referralProducts.products);

  useEffect(() => {
    document.title = "Application Confirmation";
    setClickInsightEvents(referralProducts, undefined, undefined, undefined, undefined, application.id, applicant);

    if (application.applicationEndpointReached == false) {
      // set it to true, run script
      dispatch(setApplicationEndpointReached(true));

      //setClickInsightEvents(application, "applicationSuccess", "successful");
    }

  }, []);

  const handleClick = () => {
    window.open("https://www.meridiancu.ca/", "_blank");
  }

  return (
    <FadeTransition>
      <main aria-labelledby="main-content">
        <div className="main-container max-md:mt-10">
          <div className="grid grid-cols-1 md:grid-cols-1 sm:hidden mt-10">
            <div>
              <img src="assets/acceptterms.svg" width="250" height="250" alt="accept-meridian-lending-terms"></img>
            </div>
          </div>
          <div className={style.contentContainer}>
            <div className="flex flex-col max-xs:px-3 max-md:items-center">
              <div className={style.emHeading}>
                <div className="grid grid-cols-1">
                  <h1>Contact us to start your application</h1>
                  <p>
                    We are unable to process bridge loans online at this time.
                  </p>
                  <p>
                    To apply, please call us at <span className="active">1 (866) 592-2226</span> or <a href="https://www.meridiancu.ca/contact-us/find" target="_blank" >
                    <span className="active underline">visit a Meridian branch.</span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5">
            <button
              type="submit"
              onClick={handleClick}
              style={{width: 165}}
              className={clsx("primary mt-5 w-full sm:w-28 h-11 px-6")}>
              Go to home page
            </button>
          </div>
        </div>
      </main>
    </FadeTransition>
  );
}